import { webhookDataSchema, } from '@openpeepshq/common/types';
import { parseJwtKeyId, verifyJwt } from '@openpeepshq/common/lib';
export const webhookHandler = (publicKeyEndpoint) => {
    const publicKey = undefined;
    const getPublicKey = async (kid) => {
        if (!kid) {
            throw new Error('Kid is required');
        }
        if (publicKey && publicKey === kid) {
            return publicKey;
        }
        const result = await publicKeyEndpoint();
        if ('error' in result) {
            throw result.error;
        }
        return result.data.publicKey;
    };
    return async (input) => {
        const token = typeof input === 'string' ? input : input.token;
        const tokenKeyId = parseJwtKeyId(token);
        const verification = await verifyJwt(token, await getPublicKey(tokenKeyId));
        if (!verification) {
            throw new Error('Invalid webhook token');
        }
        return webhookDataSchema.parse(verification.payload);
    };
};
